var _defs, _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeehouseLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 767.999994",
    height: 1024,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.864996, 486.331916)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 105.9375 -151.765625 C 93.625 -151.765625 84.019531 -146.722656 77.125 -136.640625 C 70.226562 -126.554688 66.78125 -112.65625 66.78125 -94.9375 C 66.78125 -58.09375 80.789062 -39.671875 108.8125 -39.671875 C 117.28125 -39.671875 125.488281 -40.847656 133.4375 -43.203125 C 141.382812 -45.566406 149.375 -48.40625 157.40625 -51.71875 L 157.40625 -7.984375 C 141.425781 -0.910156 123.351562 2.625 103.1875 2.625 C 74.289062 2.625 52.140625 -5.753906 36.734375 -22.515625 C 21.328125 -39.285156 13.625 -63.515625 13.625 -95.203125 C 13.625 -115.015625 17.351562 -132.425781 24.8125 -147.4375 C 32.28125 -162.457031 43.019531 -174.003906 57.03125 -182.078125 C 71.039062 -190.160156 87.519531 -194.203125 106.46875 -194.203125 C 127.15625 -194.203125 146.925781 -189.707031 165.78125 -180.71875 L 149.9375 -139.984375 C 142.863281 -143.304688 135.789062 -146.097656 128.71875 -148.359375 C 121.65625 -150.628906 114.0625 -151.765625 105.9375 -151.765625 Z M 105.9375 -151.765625 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.508036, 543.375)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 283.84375 0 L 203.984375 0 L 203.984375 -119.890625 L 111.640625 -119.890625 L 111.640625 0 L 31.78125 0 L 31.78125 -294.109375 L 111.640625 -294.109375 L 111.640625 -185.078125 L 203.984375 -185.078125 L 203.984375 -294.109375 L 283.84375 -294.109375 Z M 283.84375 0 "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(3.755605, 0.000000000000001276, -0.000000000000001274, 3.75, 334.88073, 541.637513)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000485509 -0.000211853 L 66.901595 -0.000211853 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeehouseLogo);
export default __webpack_public_path__ + "static/media/coffeehouse-logo.154e55b1d44a9021beb105a4a894ae11.svg";
export { ForwardRef as ReactComponent };